var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#002010"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7646 19H9.76465V21H10.7646V19ZM28.4642 20.7071C28.8547 20.3166 28.8547 19.6834 28.4642 19.2929L22.1002 12.9289C21.7097 12.5384 21.0766 12.5384 20.686 12.9289C20.2955 13.3195 20.2955 13.9526 20.686 14.3431L26.3429 20L20.686 25.6569C20.2955 26.0474 20.2955 26.6805 20.686 27.0711C21.0766 27.4616 21.7097 27.4616 22.1002 27.0711L28.4642 20.7071ZM10.7646 21L27.7571 21V19L10.7646 19V21Z",
    fill: "#C7F700"
  })));
};
export default SvgArrowRight;